import styled from 'styled-components'
import { Text } from './Text'
import { STYLES } from '../../static/style'

const ValidationText = styled(Text)`
  color: ${STYLES.COLOR_BITTER_SWEET_RED};
  position: absolute;
  right: 0;
  font-size: ${STYLES.FONT_SIZE_SM};
`

export { ValidationText }
